module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUdwTDDFNDDFMzDFMzDFNDDFMzDGMzDJMDDEMzDFMDDFMzDFNFOC/SQAAAALdFJOUwB/4LyA8FYa0DCYlF1cJwAAAH9JREFUKM9jYKAN4NTeDQWbJoAFmHbDgQJYgBshsAEhEGyKKrCrgH01ikADAwMHioADAwMLikACAwMbisACBgYuFIFwBoZSFIGt6WXRqO7AcBi6QLBbiimygBmITkYIbIGEgzdcoAEiwAEXcIAIsMAFDAXBQBiXtRhBiBHI1AcAkJ+EwDQmJV0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/profile-category.png
// module id = 1121
// module chunks = 0